import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import basketballLogo from "./images/basketball.png";
import "./Login.css";
import "./variables.css";
import API_URL from "./config";
import useAuthDarkTheme from "./useAuthDarkTheme";

const Login = () => {
  const [formData, setFormData] = useState({ username: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useAuthDarkTheme();

  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await fetch(`${API_URL}/api/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        const data = await response.json();
        setError(data.detail || "Server error");
        return;
      }

      const data = await response.json();
      const user = data.user || {};

      // Store user data and auth token
      localStorage.setItem("user", JSON.stringify(user));
      if (data.access_token) {
        localStorage.setItem("access_token", data.access_token);
      } else {
        // No access_token in response
      }

      navigate("/dashboard");
    } catch (err) {
      setError("Server error: " + (err.message || ""));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-header">
        <img src={basketballLogo} alt="Logo" className="logo" />
        <h1 className="logo-text">Courtside</h1>
      </div>

      <div className="login-titles">
        <h2 className="login-title">Log In</h2>
        <p className="login-subtitle">Log in to continue your basketball experience.</p>
      </div>

      <div className="login-container">
        <form onSubmit={handleSubmit} className="login-form">
          {/* Username field */}
          <label htmlFor="username" className="input-label">
            Username or Email
          </label>
          <input
            id="username"
            name="username"
            type="text"
            placeholder="example@gmail.com"
            value={formData.username}
            onChange={handleChange}
            required
          />

          {/* Password label + forgot link */}
          <div className="password-label-wrapper">
            <label htmlFor="password" className="input-label">
              Password
            </label>
            <a
              href="#"
              className="forgot-link"
              onClick={(e) => {
                e.preventDefault();
                navigate("/forgot-password");
              }}
            >
              Forgot Your Password?
            </a>
          </div>
          <input
            id="password"
            name="password"
            type="password"
            placeholder="Password"
            value={formData.password}
            onChange={handleChange}
            required
          />

          <button type="submit" className="login-button" disabled={loading}>
            {loading ? (
              <span className="loading-text">
                Loading
                <span className="loading-dots">
                  <span className="dot">.</span>
                  <span className="dot">.</span>
                  <span className="dot">.</span>
                </span>
              </span>
            ) : (
              "Log In"
            )}
          </button>
        </form>

        {error && <p className="error-message">{error}</p>}

        <p className="signup-text">
          Don't have an account?{" "}
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              navigate("/register");
            }}
          >
            Sign Up
          </a>
        </p>
      </div>
    </div>
  );
};

export default Login;
